import { RequestTicketStatus } from 'src/types'

export enum ReportsActionTypes {
  GET_REPORTS = '@reports/GET_REPORTS',
  GET_REPORTS_FAILURE = '@reports/GET_REPORTS_FAILURE',
  GET_REPORTS_SUCCESS = '@reports/GET_REPORTS_SUCCESS',
  GET_REPORTS_RESOURCE = '@reports/GET_REPORTS_RESOURCE',
  GET_REPORTS_RESOURCE_FAILURE = '@reports/GET_REPORTS_RESOURCE_FAILURE',
  GET_REPORTS_RESOURCE_SUCCESS = '@reports/GET_REPORTS_RESOURCE_SUCCESS',
  RESOURCE_RESET = '@reports/RESOURCE_RESET'
}
export interface R1Data {
  image_href: string
  image_number: string
  receipt_amount: number
  receipt_currency: string
  receipt_date: number
  receipt_enxange_rate: number
  receipt_number: number
  receipt_quantity: number
  receipt_type: string
  service_name: string
  total: number
  user_name: string
  user_number: number
}

interface R1Header {
  approvers_names: string
  contracts_names: string
  organizacao_name: string
  reasons_name: string
  request_date: number
  targets_names: string
}

export interface R2Data {
  full_name: string
  quantity: number
  service_name: string
  total: number
  user_id: number
}

interface R2Header {
  end_date: number
  participant_name: string
  request_number: number
  start_date: number
}

export interface R3Data {
  activity_desc: string
  ended_date: number
  local_name: string
  participant_name: string
  participant_number: number
  reference_desc: string
  request_number: number
  started_date: number
}

interface R3Header {
  ended_date: number
  organization_name: string
  participant_name: string
  started_date: number
}

export interface R4Data {
  description: string
  owner: string[]
  request_date: number
  request_number: number
  status: string
  traveler: {
    name: string
    reason: string
    status: string
    update_on: number
  }[]
}

export interface R4Header {
  requests: number
  ended_on: number
  started_on: number
  status: string
}

export interface R5Data {
  receipt_currency: string
  receipt_enxange_rate: number
  receipt_eticket_code: string
  receipt_total_sum: number
  receipt_value: number
  request_number: string
  traveler: string
}

export interface R5Header {
  ended_on: number
  requests: number
  started_on: number
  total_count: number
  total_sum: number
}

export interface R6Data {
  agency_name: string
  air_destiny: string
  company_iata: string
  departure_date: number
  e_ticket: string
  itinerary: string
  request_number: string
  tickets_total_sum: number
  traveler: string
}

export interface R6Header {
  emitted: boolean
  ended_on: number
  started_on: number
  total_request_count: number
  total_request_tickets_count: number
  total_sum: number
}

export interface R7Data {
  agency_name: string
  checkin_date: number
  checkout_date: number
  city: string
  daily: number
  e_ticket: string
  hotel: string
  request_number: number
  tickets_total_sum: number
  traveler: string
}

export interface R7Header {
  emitted: boolean
  ended_on: number
  started_on: number
  total_request_count: number
  total_request_tickets_count: number
  total_sum: number
}

export interface R8Data {
  supplier_name: string
  company: string
  e_ticket: string
  request_number: number
  return_city: string
  return_date: number
  total_value: number
  traveler: string
  withdrawal_city: string
  withdrawal_date: number
}

export interface R8Header {
  emitted: boolean
  ended_on: number
  started_on: number
  total_request_count: number
  total_request_tickets_count: number
  total_sum: number
}

export interface R9Data {
  created_on: number
  message: string
  rate: number
}

export interface R9Header {
  id: string
  avg: number
  info: number
  quantity: number
}

export interface R10Data {
  amount: number
  request_number: number
  requested_on: number
  status: string
  ticket_type: string
  title: string
}

export interface R11Data {
  active_users: number
  requests: number
}

export interface R11Header {
  ended_on: number
  started_on: number
  trade_name: string
}

export interface R12Data {
  datetrunc: number
  fullname: string
  justification: string
  quantity: number
  request_number: number
  total: number
  user_id: number
}

export interface R12Header {
  end_date: number
  start_date: number
  participant_name: string
  service: string
}

export interface R13Data {
  advances: number
  ended_on: number
  diff: number
  expenses: number
  request_number: number
  started_on: number
}

export interface R13Header {
  ended_on: number
  started_on: number
  participant: string
}

export interface R14Data {
  cost_center: string
  datetrunc: number
  justification: string
  reason: string
  request_id: number
  request_number: number
  request_ticket_receipt_number: number
  service: string
  title: string
  total: number
  traveler: string
  checked_on: number
  status: RequestTicketStatus
}

export interface R14Header {
  amount_max: string
  amount_min: string
  billing_types: string
  contracts: string
  cost_centers: string
  ended_on: number
  organizations: string
  payment_resources: string
  reasons: string
  reference: string
  request_number: string
  request_title: string
  requester: string
  services: string
  started_on: number
  targets: string
  traveler: string
}

export interface R15Data {
  cost_center: string
  datetrunc: number
  justification: string
  reason: string
  request_id: number
  request_number: number
  request_ticket_receipt_number: number
  service: string
  title: string
  total: number
  traveler: string
  checked_on: number
  status: RequestTicketStatus
}

export interface R15Header {
  amount_max: string
  amount_min: string
  billing_types: string
  contracts: string
  cost_centers: string
  ended_on: number
  organizations: string
  payment_resources: string
  reasons: string
  reference: string
  request_number: string
  request_title: string
  requester: string
  services: string
  started_on: number
  targets: string
  traveler: string
}

export type ReportsResourcesState = {
  R1Data: {
    data: R1Data[]
    error: boolean
    loading: boolean
  }
  R1Header: {
    data: R1Header[]
    error: boolean
    loading: boolean
  }
  R2Data: {
    data: R2Data[]
    error: boolean
    loading: boolean
  }
  R2Header: {
    data: R2Header[]
    error: boolean
    loading: boolean
  }
  R3Data: {
    data: R3Data[]
    error: boolean
    loading: boolean
  }
  R3Header: {
    data: R3Header[]
    error: boolean
    loading: boolean
  }
  R4Data: {
    data: R4Data[]
    error: boolean
    loading: boolean
  }
  R4Header: {
    data: R4Header[]
    error: boolean
    loading: boolean
  }
  R5Data: {
    data: R5Data[]
    error: boolean
    loading: boolean
  }
  R5Header: {
    data: R5Header[]
    error: boolean
    loading: boolean
  }
  R6Data: {
    data: R6Data[]
    error: boolean
    loading: boolean
  }
  R6Header: {
    data: R6Header[]
    error: boolean
    loading: boolean
  }
  R7Data: {
    data: R7Data[]
    error: boolean
    loading: boolean
  }
  R7Header: {
    data: R7Header[]
    error: boolean
    loading: boolean
  }
  R8Data: {
    data: R8Data[]
    error: boolean
    loading: boolean
  }
  R8Header: {
    data: R8Header[]
    error: boolean
    loading: boolean
  }
  R9Data: {
    data: R9Data[]
    error: boolean
    loading: boolean
  }
  R9Header: {
    data: R9Header[]
    error: boolean
    loading: boolean
  }
  R10Data: {
    data: R10Data[]
    error: boolean
    loading: boolean
  }
  R11Data: {
    data: R11Data[]
    error: boolean
    loading: boolean
  }
  R11Header: {
    data: R11Header[]
    error: boolean
    loading: boolean
  }
  R12Data: {
    data: R12Data[]
    error: boolean
    loading: boolean
  }
  R12Header: {
    data: R12Header[]
    error: boolean
    loading: boolean
  }
  R13Data: {
    data: R13Data[]
    error: boolean
    loading: boolean
  }
  R13Header: {
    data: R13Header[]
    error: boolean
    loading: boolean
  }
  R14Data: {
    data: R14Data[]
    error: boolean
    loading: boolean
  }
  R14Header: {
    data: R14Header[]
    error: boolean
    loading: boolean
  }
  R15Data: {
    data: R15Data[]
    error: boolean
    loading: boolean
  }
  R15Header: {
    data: R15Header[]
    error: boolean
    loading: boolean
  }
}

export type ReportsResourcesAvailable = {
  R1Data: R1Data
  R1Header: R1Header
  R2Data: R2Data
  R2Header: R2Header
  R3Data: R3Data
  R3Header: R3Header
  R4Data: R4Data
  R4Header: R4Header
  R5Data: R5Data
  R5Header: R5Header
  R6Data: R6Data
  R6Header: R6Header
  R7Data: R7Data
  R7Header: R7Header
  R8Data: R8Data
  R8Header: R8Header
  R9Data: R9Data
  R9Header: R9Header
  R10Data: R10Data
  R11Data: R11Data
  R11Header: R11Header
  R12Data: R12Data
  R12Header: R12Header
  R13Data: R13Data
  R13Header: R13Header
  R14Data: R14Data
  R14Header: R14Header
  R15Data: R15Data
  R15Header: R15Header
  //novo R+
}

export type ResourcesHttpData<K extends keyof ReportsResourcesAvailable> = {
  report_data: ReportsResourcesAvailable[K][]
}

export interface ReportsState {
  readonly error: boolean
  readonly loading: boolean
  readonly reportsList: Report[]
  readonly reportsResources: ReportsResourcesState
}

export enum ReportType {
  DASHBOARD = 'DASHBOARD',
  REPORT = 'REPORT',
  RESOURCES = 'RESOURCES'
}

export interface Report {
  description: string
  filters: string
  name: string
  report_class: string
  report_data_id: number
  report_type: ReportType
  resources: { [K in keyof ReportsResourcesAvailable]: number }
}
